import React from 'react'

import helmail from "../images/HELP LINE MAIL NEW.jpg";

function BarniaMap() {
  return (
    <div>


<div className="album py-0">

<div className="container">

  <div className="row">
  <div className="col-md-6 mt-3">
  <img src={helmail} className="d-block w-100" alt="Best Garments showroom in Bethuadahari, West Bengal"/>

</div>
<div className="col-md-6 mt-3">
  <iframe className="iframe-fluid mb-1" width="520" height="333" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=%E0%A6%B8%E0%A6%BF%E0%A6%A6%E0%A7%8D%E0%A6%A7%E0%A7%87%E0%A6%B6%E0%A7%8D%E0%A6%AC%E0%A6%B0%E0%A7%80%20%E0%A6%AC%E0%A6%B8%E0%A7%8D%E0%A6%A4%E0%A7%8D%E0%A6%B0%E0%A6%BE%E0%A6%B2%E0%A6%AF%E0%A6%BC%20(%E0%A6%AC%E0%A6%BE%E0%A6%B0%E0%A7%8D%E0%A6%A8%E0%A6%BF%E0%A6%AF%E0%A6%BC%E0%A6%BE)%20Siddheswari%20Bastralay%20(Barnia),%20Barnia%20front%20of%20Vivakananda%20more,%20Barnia,%20West%20Bengal%20741156%20+(%E0%A6%B8%E0%A6%BF%E0%A6%A6%E0%A7%8D%E0%A6%A7%E0%A7%87%E0%A6%B6%E0%A7%8D%E0%A6%AC%E0%A6%B0%E0%A7%80%20%E0%A6%AC%E0%A6%B8%E0%A7%8D%E0%A6%A4%E0%A7%8D%E0%A6%B0%E0%A6%BE%E0%A6%B2%E0%A6%AF%E0%A6%BC%20(%E0%A6%AC%E0%A6%BE%E0%A6%B0%E0%A7%8D%E0%A6%A8%E0%A6%BF%E0%A6%AF%E0%A6%BC%E0%A6%BE)%20Siddheswari%20Bastralay%20(Barnia),%20Barnia%20front%20of%20Vivakananda%20more,%20Barnia,%20West%20Bengal%20741156)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe> 
  </div>

  <iframe className='mt-2' src="https://www.google.com/maps/embed?pb=!4v1739604832220!6m8!1m7!1smuz_WQmssKy7CC1Ypdi3wA!2m2!1d23.72393518352571!2d88.4230328846565!3f302.606875636356!4f17.167234844872468!5f1.1426642809143206" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

  </div>
</div>

</div>


    </div>
  )
}

export default BarniaMap